import { Flex, Text } from "@chakra-ui/react";

interface CardExtractDetailsProps {
  valor: number | undefined;
  description: string;
  color: string;
}

export default function CardExtractDetails({
  valor,
  description,
  color,
}: CardExtractDetailsProps) {
  const formattedValor = typeof valor === "number" ? valor : 0;

  return (
    <Flex
      height="60px"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Text color={color} fontSize="18px" fontWeight="bold">
        {formattedValor.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        })}
      </Text>
      <Text color="gray" fontSize="12px">
        {description}
      </Text>
    </Flex>
  );
}
